import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Item } from '../../model/item';
import { Answer } from '../../model/answer';
import { Observable, Subject, asapScheduler, pipe, of, from, interval, merge, fromEvent } from 'rxjs';
import { AnswerControlService } from '../answer/answerControl.service';
import { CONFIG } from '../../constants/constants';
import { TokenControlService } from "../state/tokenControl.service"
import * as CryptoJS from "crypto-js";

/*Servicio para encripcion y des-encripcion,
  utiliza el estandar webCryptoAPI [debe ser soportado por el navegador]
  si el navegador no soporta webCryptoAPI este servicio no puede ser usado*/
@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  //llave para encripcion
  private key_items: any = null;

  //llave para encripcion
  private key_rtas: any = null;

  //vector de inicializacion
  private vector: any = null;

  /**Almacena el contenido actual del item Encriptado */
  private content: String;

  /** Controla el numero de intentos permitidos en una promesa */
  private counter: number;

  //constructor de la clase
  constructor(private _answerController: AnswerControlService,
    private _tokenControlService: TokenControlService) {
    let self = this;
    var getKey;

    self.vector = crypto.getRandomValues(new Uint8Array(16));

    let promise_key_items = crypto.subtle.generateKey(
      { name: "AES-CBC", length: 128 }, false, ["encrypt", "decrypt"]
    );

    promise_key_items.then(result => {
      self.key_items = result;
    }, err => {
      console.log('Error obteniendo key');
    });

    let promise_key_archivo = crypto.subtle.generateKey(
      { name: "AES-CBC", length: 128 }, true, ["encrypt", "decrypt"]
    );

    promise_key_archivo.then(result => {
      self.key_rtas = result;
      var json_key = null;
      var string_key = null;
      var getKey = crypto.subtle.exportKey("jwk", self.key_rtas);
      getKey.then(result => {
        json_key = result;
        string_key = JSON.stringify(json_key);
      }, err => {
        console.log('Error obteniendo key_rtas');
      })

    }, err => {
      console.log('Error obteniendo key respuestas');
    });

    this.counter = 0;

  }

  //Se encarga de encriptar la informacion que llega por parametro
  public encrypt_data(data: string): Promise<string> {
    return new Promise(resolve => {
      let self = this;
      let encryptedStr = '';
      let encrypted_data = null;
      let encrypt_promise = crypto.subtle.encrypt(
        { name: "AES-CBC", iv: self.vector },
        self.key_items, self.convertStringToArrayBufferView(data)
      );

      encrypt_promise.then(result => {
        encrypted_data = new Uint8Array(result);
        encryptedStr =
          self.convertArrayBufferViewtoString(encrypted_data);
        resolve(encryptedStr);


      },
        err => {
          console.log('string encription error');
          resolve('');
        });
    });
  }

  //Se encarga de des-encriptar la informacion que llega por parametro
  public decrypt_data(encrypted_data: any, formEncp: boolean): Promise<string> {
    return new Promise(resolve => {
      let self = this;
      let decryptedStr = '';
      let decrypt_promise = null;
      if (formEncp) {
        decrypt_promise =
          crypto.subtle.decrypt(
            { name: "AES-CBC", iv: self.vector },
            self.key_items,
            self.convertStringToArrayBufferView(encrypted_data)
          );
      } else {
        decrypt_promise =
          crypto.subtle.decrypt(
            { name: "AES-CBC", iv: self.vector },
            self.key_rtas,
            self.convertStringToArrayBufferView(encrypted_data)
          );
      }

      decrypt_promise.then(
        result => {
          let decrypted_data = new Uint8Array(result);
          decryptedStr =
            self.convertArrayBufferViewtoString(decrypted_data);
          resolve(decryptedStr);
        },
        err => {
          console.log('string decription error');
          console.log(err);
          resolve('');
        }
      );
    });
  }



  //Se encarga de encriptar la informacion que llega por parametro
  public encrypt_data_file(data: string): Promise<string> {
    return new Promise(resolve => {
      let self = this;
      let encryptedStr = '';
      let encrypted_data = null;
      let encrypt_promise =
        crypto.subtle.encrypt(
          { name: "AES-CBC", iv: self.vector },
          self.key_rtas, self.convertStringToArrayBufferView(data)
        );


      encrypt_promise.then(result => {
        encrypted_data = new Uint8Array(result);
        encryptedStr =
          self.convertArrayBufferCadena(encrypted_data);
        resolve(encryptedStr);


      },
        err => {
          console.log('string encription error');
          resolve('');
        });
    });
  }

  //Se encarga de des-encriptar la informacion que llega por parametro
  public decrypt_data_File(encrypted_data: any, vector: any, key_rtas: CryptoKey): Promise<string> {
    return new Promise(resolve => {
      let self = this;
      let decryptedStr = '';
      var conver = self.convertArrayBufferToString(encrypted_data);
      let decrypt_promise =
        crypto.subtle.decrypt(
          { name: "AES-CBC", iv: vector },
          key_rtas,
          self.convertStringToArrayBufferView(conver)
        );
      decrypt_promise.then(
        result => {
          let decrypted_data = new Uint8Array(result);
          decryptedStr =
            self.convertArrayBufferViewtoString(decrypted_data);
          resolve(decryptedStr);
        },
        err => {
          console.log(err);
          resolve('');
        }
      );
    });
  }

  /** Metodo encargado de desencriptar un item */
  public decrypt_Item(content: any): Promise<any> {
    this.content = content;
    return new Promise(resolve => {
      if (CONFIG.ONLINE) {
        let arrayFilas = content.split("vvvvvv");
        let contenidoItem = content.substring(0, content.length - 44);
        let keyItem = content.substring(content.length - 44, content.length);
        let key = CryptoJS.enc.Base64.parse(keyItem);

        var decryptedData = CryptoJS.AES.decrypt(contenidoItem, key, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        });
        var decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
        resolve(decryptedText);
      }
      else {
        resolve(content)
      }
    }).catch(err => {
      console.log(err);
      this.counter += 1;
      if (this.counter < 3) {
        this.decrypt_Item(this.content);
      } else {
        this.counter = 0;
      }

    })

  }

  //Se encarga de convertir una cadena string en un array de bytes
  private convertStringToArrayBufferView(str: string) {
    let bytes = new Uint8Array(str.length);
    for (let iii = 0; iii < str.length; iii++) {
      bytes[iii] = str.charCodeAt(iii);
    }
    return bytes;
  }

  //Se encarga de convertir una cadena string en un array de bytes
  public convertStringToArrayBufferView16(str: string) {
    let bytes = new Int16Array(str.length);

    for (let iii = 0; iii < str.length; iii++) {
      bytes[iii] = str.charCodeAt(iii);
    }
    return bytes;
  }

  //Convierte un buffer de array en una cadena string
  private convertArrayBufferViewtoString(buffer: any): string {
    let str = "";
    for (let iii = 0; iii < buffer.byteLength; iii++) {
      str += String.fromCharCode(buffer[iii]);
    }
    return str;
  }


  //Convierte un buffer de array en una cadena string
  private convertArrayBufferCadena(buffer: any) {
    let str = "";
    for (let iii = 0; iii < buffer.byteLength; iii++) {
      str += buffer[iii] + ",";
    }
    return str;
  }

  //Convierte un buffer de array en una cadena string
  private convertArrayBufferToString(buffer: string) {
    let str = "";
    var arrayFilas: string[];
    arrayFilas = buffer.split(",");

    for (let iii = 0; iii < arrayFilas.length; iii++) {
      if (arrayFilas[iii] != "") {
        var aNumber: number = parseInt(arrayFilas[iii]);
        str += String.fromCharCode(aNumber);
      }

    }

    return str;
  }

  //obtiene el valor de la llave de respuestas
  get key(): CryptoKey {
    return this.key_rtas;
  }

  //obtiene el valor del vector
  get vectorIV(): any {
    return this.vector;
  }

  encryptDataSumadi(value: string, key: string): string {
    return CryptoJS.AES.encrypt(value, key).toString();
  }

  decryptDataSumadi(textToDecrypt: string, key: string) {
    return CryptoJS.AES.decrypt(textToDecrypt, key).toString(CryptoJS.enc.Utf8);
  }
}
